import type React from 'react';
import type { MouseEvent } from 'react';

import * as styles from './styles';
import { Button, Divider } from '@cobliteam/ui/components';
import { cn } from '@cobliteam/ui/utils';

import { BodyText, type DialogProps, DialogWithHeader } from '@cobliteam/base-components';

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export interface ConfirmationModalProps extends Pick<DialogProps, 'maxWidth'> {
  open: boolean;
  children: React.ReactNode;
  loading?: boolean;
  confirmationButtonProps?: any;
  cancelButtonProps?: any;
  onCancel: (event: MouseEvent<HTMLButtonElement>) => void;
  onMouseOverCancel?: (event: MouseEvent<HTMLButtonElement>) => void;
  onConfirm: () => void;
  hideConfirmButton?: boolean;
  hideCancelButton?: boolean;
  headerText: string;
  buttonText: string;
  type: ModalType;
  buttonIcon?: React.ReactNode;
  scroll?: DialogProps['scroll'];
  cancelButtonText?: string;
  onCloseButtonClick?: () => void;
  className?: string;
  reverseButtons?: boolean;
}

type ButtonGroupProps = Pick<
  ConfirmationModalProps,
  | 'onCancel'
  | 'onMouseOverCancel'
  | 'onConfirm'
  | 'hideConfirmButton'
  | 'hideCancelButton'
  | 'buttonText'
  | 'buttonIcon'
  | 'loading'
  | 'className'
  | 'reverseButtons'
  | 'confirmationButtonProps'
  | 'cancelButtonProps'
  | 'type'
  | 'cancelButtonText'
>;

export enum ModalType {
  SUBMIT = 'SUBMIT',
  DELETE = 'DELETE',
}

export const ButtonGroup: React.FC<ButtonGroupProps> = (props) => {
  return (
    <div className={cn('flex items-center justify-end gap-10', props.reverseButtons ? 'flex-row-reverse' : 'flex-row', props.className)}>
      {props.hideCancelButton ? null : (
        <Button variant='text' disabled={props.cancelButtonProps?.disabled} className='text-wrap' onClick={props.onCancel} onMouseOver={props.onMouseOverCancel}>
          {props.cancelButtonText || 'Cancelar'}
        </Button>
      )}
      {props.hideConfirmButton ? null : (
        <Button
          color={props.type === ModalType.DELETE ? 'danger' : 'primary'}
          startIcon={props.buttonIcon}
          loading={props.loading}
          className='text-wrap text-white'
          onClick={props.onConfirm}
          disabled={props.confirmationButtonProps?.disabled}
        >
          {props.buttonText}
        </Button>
      )}
    </div>
  );
};

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Use the Dialog component from @cobliteam/ui/components/Dialog instead.
 */
export const ConfirmationModal: React.FC<ConfirmationModalProps> = (props) => (
  <DialogWithHeader
    className={props.className}
    open={props.open}
    maxWidth={props.maxWidth || 'sm'}
    title={props.headerText}
    actions={
      <ButtonGroup
        onCancel={props.onCancel}
        onMouseOverCancel={props.onMouseOverCancel}
        onConfirm={props.onConfirm}
        buttonText={props.buttonText}
        buttonIcon={props.buttonIcon}
        cancelButtonText={props.cancelButtonText}
        type={props.type}
        loading={props.loading}
        hideConfirmButton={props.hideConfirmButton}
        hideCancelButton={props.hideCancelButton}
        confirmationButtonProps={props.confirmationButtonProps}
        cancelButtonProps={props.cancelButtonProps}
        reverseButtons={props.reverseButtons}
      />
    }
    onClose={props.onCancel}
    onCloseButtonClick={props.onCloseButtonClick}
    disableEscapeKeyDown
    scroll={props.scroll}
  >
    <div className={styles.modalBody}>
      <BodyText className={styles.modalText}>{props.children}</BodyText>
      <Divider />
    </div>
  </DialogWithHeader>
);
